<template>
  <section>
    <b-modal
      ref="modalLogin"
      ok-title="Acceder"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-backdrop
    >
      <b-overlay :show="loading" no-wrap></b-overlay>
      <div class="text-center">
        <img :src="logo" style="max-width: 300px" /><br />
        SUPPLIERS
      </div>
      <hr />
      <b-form ref="loginForm" @submit="onSubmit">
        <div class="row justify-content-md-center">
          <div class="col-sm-8">
            <b-form-group label="Email">
              <b-form-input
                v-model="form.email"
                type="email"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Password">
              <b-form-input
                v-model="form.password"
                type="password"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="text-center">
          <p class="text-danger" v-if="error">{{ error_message }}</p>
          <a href="/reset-passwd" @click="$root.setRouteEvt"
            >Did you forget your password?</a
          >
        </div>
        <hr />
        <div class="text-right">
          <b-button variant="primary" type="submit">LOGIN</b-button>
        </div>
      </b-form>
    </b-modal>

    <Single ref="single" />
  </section>
</template>

<script>
import logo from "../../../assets/logo-sc-negro.png";
import Single from "./Single";

export default {
  components: { Single },
  data() {
    return {
      logo,
      form: {
        email: "",
        password: "",
        type: "supplier",
      },
      error: false,
      error_message: "Wrong username o password",
      loading: false,
    };
  },
  methods: {
    isEmail(valor) {
      // eslint-disable-next-line
      var cor =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; /* eslint-disable-line */
      if (cor.test(valor)) {
        return true;
      } else {
        return false;
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      //validate input email
      if (!this.isEmail(this.form.email)) {
        this.error = true;
        this.error_message = "Email is not correct";
        return;
      }
      //validate password blanks
      this.form.password = this.form.password.trim();

      // init values error and loadign
      this.error = false;
      this.loading = true;

      //   get token
      this.$root.api
        .post("/auth/login", this.form)
        .then((res) => {
          // check if user has options
          if (res.data.options.supplier === null)
            this.$root.showAlert("No tienes acceso a este sistema", {
              variant: "warning",
            });

          // validate if has more than 1 access
          if (res.data.options.supplier.length === 1) {
            // set user token
            this.$root.store.setUserToken(res.data.token.access_token);

            let system = res.data.options.supplier[0].id;
            this.$root.api
              .post("/auth/system", null, {
                headers: {
                  "X-SC-TYPE": "supplier",
                  "X-SC-SYSTEM": system,
                },
              })
              .then((response) => {
                this.$root.store.setSystemData(response.data);

                this.$root.api.post("/auth/me").then((response2) => {
                  this.$root.store.setUserData(response2.data);
                  this.$router.push("/");
                });
              })
              .catch(() => {
                this.loading = false;
                this.error = true;
              });
          } else if (res.data.options.supplier.length > 1) {
            // show modal & set user token
            this.$root.store.setUserToken(res.data.token.access_token);
            this.$refs["single"].loadModel(res.data.options);
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.error = true;
          this.error_message = "Wrong username o password";
        });
    },
  },
  mounted() {
    this.$refs["modalLogin"].show();
  },
  beforeCreate() {
    // access from pos
    if (
      Object.entries(this.$route.query).length !== 0 &&
      this.$route.query.referenceId &&
      this.$route.query.token
    ) {
      this.loading = true;

      let token =
        typeof this.$route.query.token !== "string"
          ? null
          : this.$route.query.token;
      let referenceId =
        typeof this.$route.query.referenceId !== "string"
          ? null
          : this.$route.query.referenceId;

      if (referenceId !== null && token !== null) {
        // set token
        this.$root.store.setUserToken(token);

        this.$root.api
          .post("/auth/system", null, {
            headers: {
              "X-SC-TYPE": "supplier",
              "X-SC-SYSTEM": referenceId,
            },
          })
          .then((response) => {
            // set system data
            this.$root.store.setSystemData(response.data);

            this.$root.api.post("/auth/me").then((response2) => {
              this.$root.store.setUserData(response2.data);
              this.$router.push("/");
              this.loading = false;
            });
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.error = true;
          });
      }
    } else {
      this.$root.auxVars.clearResources();
      this.$root.store.clearUser();
    }
  },
};
</script>

<style>
</style>
